import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { services as mockServices, faqs as mockFaqs, testimonials as mockTestimonials } from '../data/mock';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentCtx = createContext({
  services: mockServices,
  faqs: mockFaqs,
  testimonials: mockTestimonials,
  loading: true,
  refresh: () => {},
});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({
    services: mockServices,
    faqs: mockFaqs,
    testimonials: mockTestimonials,
    loading: true,
  });

  const fetchContent = async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent({
        services: data.services?.length ? data.services : mockServices,
        faqs: data.faqs?.length ? data.faqs : mockFaqs,
        testimonials: data.testimonials?.length ? data.testimonials : mockTestimonials,
        loading: false,
      });
    } catch (e) {
      // fallback to mock (already set)
      setContent((c) => ({ ...c, loading: false }));
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  return (
    <ContentCtx.Provider value={{ ...content, refresh: fetchContent }}>
      {children}
    </ContentCtx.Provider>
  );
};

export const useContent = () => useContext(ContentCtx);
